import { Card, Container } from "react-bootstrap";
import "./BasicDetailsContainer.styles.css";

function BasicDetailsContainer({ children }) {
  return (
    <Container className="details-container text-start px-0 py-5">
      <Card className="details-container__card">{children}</Card>
    </Container>
  );
}

export default BasicDetailsContainer;
